// Zod Schema pour les Tabs.

import { z } from "zod";

export const tabSchema = z.object({
  id: z.string().min(1, "Id Should be a number"),
  tab_name: z.string().min(1, "Tab Name is required"),
  link: z.string().min(1, "Link is required"),
  link_type: z.string().min(1, "Link Type is required"),
});
